import { render, staticRenderFns } from "./OperationPayments.vue?vue&type=template&id=74affffe&scoped=true"
import script from "./OperationPayments.vue?vue&type=script&lang=ts"
export * from "./OperationPayments.vue?vue&type=script&lang=ts"
import style0 from "./OperationPayments.vue?vue&type=style&index=0&id=74affffe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74affffe",
  null
  
)

export default component.exports